import { Card } from '@/components/ui/card';
import { CheckCircle2, Target, TrendingUp, Zap } from 'lucide-react';

export const SolutionSection = () => {
  const benefits = [
    {
      icon: Zap,
      title: 'Supports referees with better decision making',
      description: 'Real-time assistance that helps officials make accurate calls with confidence'
    },
    {
      icon: Target,
      title: 'Reduces incorrect calls',
      description: 'Advanced technology minimizes human error and controversial decisions'
    },
    {
      icon: CheckCircle2,
      title: 'Improves fairness',
      description: 'Ensures every team gets a fair chance and decisions are consistent'
    },
    {
      icon: TrendingUp,
      title: 'Designed for grassroots football',
      description: 'Affordable and accessible technology built specifically for local clubs and leagues'
    }
  ];
  
  return (
    <section className="py-16 sm:py-24 lg:py-32 relative overflow-hidden">
      {/* Background Accent */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_hsl(158_64%_52%_/_0.08),_transparent_70%)]" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-12 sm:mb-16">
          <span className="inline-block text-sm font-semibold text-secondary uppercase tracking-wider mb-3">Our Solution</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4 sm:mb-6 font-['Space_Grotesk']">
            Technology that makes a difference
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground">
            Empowering referees and improving the game for everyone
          </p>
        </div>
        
        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 max-w-5xl mx-auto">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <Card 
                key={index}
                className="bg-card border-border/50 p-6 sm:p-8 hover:border-secondary/30 transition-all duration-300 group hover:shadow-[0_0_30px_hsl(158_64%_52%_/_0.1)]"
              >
                <div className="flex flex-col h-full">
                  <div className="flex items-start gap-4 mb-4">
                    <div className="w-12 h-12 rounded-xl bg-secondary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-secondary/20 transition-colors">
                      <Icon className="w-6 h-6 text-secondary" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-2 font-['Space_Grotesk']">
                        {benefit.title}
                      </h3>
                    </div>
                  </div>
                  <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
